import React from 'react';
import { getStageName } from './index';
import { ISnackbar } from '../Types';
import { ILine, IStage } from '../global';
import StageDateErrorHeader from '../components/BuildingBlocks/Lines/Stages/StageDateErrorHeader';
import cloneDeep from 'lodash.clonedeep';

export function addOrDeleteLineEditError(
  errors: object,
  addError: boolean = true,
  errKey: string,
  error?: string,
) {
  if (addError) {
    errors[errKey] = error;
  } else {
    delete errors[errKey];
  }
}

function getStageErrorHeader(key: string, stages: Array<IStage>) {
  // STRUCUTRE OF KEY IS stage.<id>.<amount_or_date>
  let header = null;
  const errorKeySplit = key.split('.');
  const stageId = errorKeySplit[1];
  const errorType = errorKeySplit[2];
  const stage = stages.find((stage) => stage.id === stageId);
  const stageName = getStageName(stage?.name);
  if (errorType === 'amount') {
    header = `Invalid amount (${stageName})`;
  }
  if (errorType === 'date') {
    header = <StageDateErrorHeader stage={stage?.name} />;
  }
  return header;
}

function removeErrorsForDeletedStages(stages: Array<IStage>, errors: object) {
  const deletedStages = stages.filter((stage) => stage.deleted);
  deletedStages.forEach((stage) => {
    addOrDeleteLineEditError(errors, false, 'stage.' + stage.id + '.amount');
    addOrDeleteLineEditError(errors, false, 'stage.' + stage.id, '.date');
  });
}

function removeErrorsForUndefinedStages(stages: Array<IStage>, errors: object) {
  // SOMETIMES, DUE TO THE WAY WE HANDLE KEYS WHEN WE MAP THE STAGES,
  // AN ERROR CAN BE SET FOR AN EMPTY STAGE ON DELETE
  // THIS CLEARS OUT THIS FALSE ERRORS
  const errorKeys = Object.keys(errors);
  const stageErrors = errorKeys.filter((error) => error.includes('stage'));
  stageErrors.forEach((error) => {
    const errorKeySplit = error.split('.');
    const stageId = errorKeySplit[1];
    const stageExists = stages.find((stage) => stage.id === stageId);
    if (!stageExists) {
      delete errors[error];
    }
  });
}

export function displayLineEditErrors(
  lineBeingEdited: ILine,
  errorList: object,
  snackbar: ISnackbar,
) {
  removeErrorsForDeletedStages(lineBeingEdited.stages, errorList);
  removeErrorsForUndefinedStages(lineBeingEdited.stages, errorList);
  let displayedError = false;
  const errorListCopy = cloneDeep(errorList);
  const errorKeys = Object.keys(errorListCopy);
  const errors = Object.values(errorListCopy);
  if (errors.length > 0) {
    const err = errors[0];
    const errKey = errorKeys[0];
    let header = null;
    if (errKey === 'name') {
      header = 'Invalid name';
    }
    if (errKey === 'inventory') {
      header = 'Invalid inventory';
    }
    if (errKey.includes('stage')) {
      header = getStageErrorHeader(errKey, lineBeingEdited.stages);
    }
    displayedError = true;
    snackbar.show(err as string, 'error', 5000, header);
  }
  return displayedError;
}
